module.exports = __webpack_public_path__ + "public/img/Strategi Iklan Digital Marketing Online.3b9dd5bc.png";